import { LinearProgress } from 'components/LinearProgress';
import { PartnerData } from 'components/PartnerView/PartnerData';
import { PartnerHeader } from 'components/PartnerView/PartnerHeader';
import { PartnerTypes } from 'components/PartnerView/PartnerTypes';
import { usePartnerAdmin } from 'hooks/usePartnersAdmin';
import { PartnerService } from 'services';
import { IPartner } from 'types/Partner';

import { Box, Grid, Paper } from '@mui/material';

type IPartnerDataProfile = {
  borderOrange: string;
  id: string;
  partner?: IPartner;
};

export const PartnerDataProfile: React.FC<IPartnerDataProfile> = ({
  borderOrange,
  id,
  partner,
}) => {
  const { loading } = usePartnerAdmin();

  return (
    <Paper
      variant="outlined"
      sx={{ border: '2px solid', borderColor: borderOrange }}
    >
      {loading && <LinearProgress />}
      <Box p={2}>
        <Grid container alignItems="flex-start" spacing={3}>
          <Grid item container xs={12} md={12} justifyContent="space-between">
            <PartnerHeader
              borderOrange={borderOrange}
              logo={PartnerService.getPartnerImage(id)}
            />
            <PartnerTypes types={partner?.types} />
          </Grid>
        </Grid>
        <PartnerData data={partner} />
      </Box>
    </Paper>
  );
};

